import { render } from "./Or_tableJyutu.vue?vue&type=template&id=34e691fa&scoped=true&ts=true"
import script from "./Or_tableJyutu.vue?vue&type=script&lang=ts"
export * from "./Or_tableJyutu.vue?vue&type=script&lang=ts"

import "./Or_tableJyutu.vue?vue&type=style&index=0&id=34e691fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e691fa"]])

export default __exports__